var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-icon p-half pb-0 btn-secondary",attrs:{"title":"Keepa","type":"button"},on:{"click":_vm.handleClick}},[_c('i',{staticClass:"icon-psh-keepa fs-4"})])}
var staticRenderFns = []

export { render, staticRenderFns }